import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdelinkModuleTheme, useIdelinkTheme } from '../../configs/IdeLinkTheme';
import { NavbarModuleItem } from '../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { Module } from '../Module';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { PrivateRoute } from '../../routes/PrivateRoute';
import { PermissionsActions } from '../../services/permissions/PermissionsActions';
import { StatsListPageLoading } from './Pages/StatsListPage/StatsListPageLoading';
import { StatsPermissions } from './Services/StatsPermissions';

export class StatsModule {
    public static STAT_LIST: string = '/stats';

    private static getStatListRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: StatsModule.STAT_LIST,
            component: StatsListPageLoading,
            hasAccess: () => StatsPermissions.Admin.canRead,
        },
    });

    public static getStatsRoutes = (): Array<RouteItem> => [StatsModule.getStatListRoute()];

    public static preloadStatsListPage = () => {
        StatsListPageLoading.preload();
    };

    public static getStatsModuleNavbar = (statsTheme: IdelinkModuleTheme): NavbarModuleItem => {
        return {
            icon: statsTheme.navbarIcon,
            label: <FormattedMessage id="navbar.stats" />,
            route: StatsModule.STAT_LIST,
            onMouseOver: () => StatsModule.preloadStatsListPage(),
            disabled: !StatsPermissions.Admin.canRead,
            hide: PermissionsActions.shouldHideAdminSection(),
        };
    };
}

export const IdkStatsModule = () => {
    const ideLinkTheme = useIdelinkTheme();
    return (
        <Module
            moduleKey="StatsModule"
            routes={StatsModule.getStatsRoutes()}
            navBarItems={[StatsModule.getStatsModuleNavbar(ideLinkTheme.stats)]}
        />
    );
};
